import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfigApi } from 'Api/ConfigApi';
import { updatePrimaryFooter } from 'State/Layouts/LayoutActions';
import PrimaryFooter from './PrimaryFooter';

class PrimaryFooterComponent extends Component {
  componentDidMount() {
    const {
      pageLayout: { footerContent },
    } = this.props;
    if (!footerContent.isLoaded) this.getFooterContent();
  }

  getFooterContent = async () => {
    const { updatePrimaryFooter } = this.props;
    try {
      const footerResponse = await getConfigApi('/footer');
      if (footerResponse.data) updatePrimaryFooter(footerResponse.data);
    } catch (err) {
      console.error(err.message);
    }
  };

  render() {
    const {
      pageLayout: { footerContent },
    } = this.props;

    if (!footerContent.isLoaded) {
      return null;
    }

    return <PrimaryFooter {...this.props} {...footerContent.content} />;
  }
}

const PrimaryFooterContainer = connect(
  ({ pageLayout }) => ({
    pageLayout,
  }),
  { updatePrimaryFooter }
)(PrimaryFooterComponent);

export default PrimaryFooterContainer;
